import * as R from 'ramda';
import {call, put, takeLatest} from 'redux-saga/effects';
import { push } from "react-router-redux";
import {showNotification, refreshView} from 'react-admin';
import * as actions from './actions';
import {dataProvider} from '../../App';


function uploadCSV(payload) {
    return dataProvider(actions.UPLOAD_CSV_TO_STATIONS, 'stations', payload)
        .then(({data}) => ({result: data}))
        .catch(error => ({error}))
}


function* handleCSVUpload(action) {
    const {payload} = action;
    const {result, error} = yield call(uploadCSV, payload);
    if (result) {
        yield put(actions.SUCCESS_UPLOAD_CSV_TO_STATIONS);
        yield put(push("/stations"));
        yield put(refreshView());
    } else {
        const errorMsg = R.pathOr('Unknown error', ['body', 'userMessage'], error);
        yield put(showNotification(errorMsg, 'warning'));
    }
}


export default function* stationSaga() {
    yield takeLatest(actions.START_UPLOAD_CSV_TO_STATIONS, handleCSVUpload);
}